<template>
  <v-snackbar app elevation="2" class="white--text text-pre-wrap" :color="color" v-model="visible" :timeout="timeout">
    <v-icon left size="26" color="rgba(255,255,255, 0.5)" class="ml-0 mr-2">{{ color !== "info" ? "mdi-alert-octagon" : "mdi-information-outline" }}</v-icon>
    {{ text }}
    <template v-if="color !== 'info'" v-slot:action="{ attrs }">
      <v-btn
          text
          v-bind="attrs"
          @click="visible = false"
      >Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  name: "Toast",
  data() {
    return {
      color: "info",
      visible: false,
      timeout: 6000,
      text: null
    }
  },
  mounted() {
    this.$bus.$on("msg", (text, type) => {
      if (type === "error") {
        this.color = "error";
        this.timeout = -1;
      } else {
        this.color = "info";
        this.timeout = 6000;
      }
      this.text = text;
      this.visible = true;
    });

    this.$bus.$on("closeMsg", () => {
      this.visible = false;
    });
  },
  beforeDestroy() {
    this.$bus.$off("msg");
    this.$bus.$off("closeMsg");
  }
}
</script>

<style scoped>

</style>